<template>
  <j-modal
    :title="title"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <a-table
      ref="table"
      size="middle"
      bordered
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      class="j-table-force-nowrap"
      @change="handleTableChange">

        <span slot="colId" slot-scope="text, record" >
          <a v-if="record.colId != null" @click="unBind(record.appid)">{{language['system.relieveBind']}}</a>
          <div v-else>
            <a  @click="bind(record.appid)">{{language['system.bind']}}</a>
          </div>
        </span>
       <!-- <span slot="action" slot-scope="text, record" v-if="(record.auditStatus==null||record.auditStatus=='rejected'||record.auditStatus=='approved')&&record.relationId==null">
           <a-popconfirm :title="language['user.apply.cofing']" @confirm="() => appAuthorize(record.appid)">
             <a>{{ language['user.apply.authorize'] }}</a>
           </a-popconfirm>
        </span>-->

    </a-table>

  </j-modal>
</template>

<script>
  import {httpAction, getAction} from '@/api/manage'
    export default {
      name: "UserApplicationModel",
      data() {
        return {
          description: '',
          url: {
            list: "/hhemp/colApplication/empcolapplications",
            add: "/sys/sysUserApplicationApply/userBindApplication"
          },

          title:this.$store.getters.language['user.bindApplicationBtn'],
          width: 800,
          visible: false,
          disableSubmit: false,
          confirmLoading:false,
          queryParam: {},
          ipagination:{
            current: 1,
            pageSize: 10,
            showQuickJumper: false,
            showSizeChanger: false,
            total: 0
          },
          dataSource:[],
          model:{},
        }
      },
      computed: {
        language() {
          return this.$store.getters.language
        },
        columns() {
          if (this.language) {
            return [
              {
                title: '#',
                dataIndex: '',
                key: 'rowIndex',
                width: 60,
                align: "center",
                customRender: function (t, r, index) {
                  return parseInt(index) + 1;
                }
              },
              {
                title: this.language['user.apply.system.name'],
                align: "center",
                dataIndex: 'applicationName',
                width: 180
              },
              {
                title: this.language['user.apply.description'],
                align: "center",
                dataIndex: 'applicationDesc',
                width: 180
              },
              {
                title: this.language['user.apply.or.authorize'],
                align: "center",
                dataIndex: 'colId',
                width: 147,
                scopedSlots: {customRender: 'colId'},
              },
            ]
          }
        },
      },
      methods:{
        edit (record) {
          this.visible = true
          /*this.ipagination.current = 1;
          this.ipagination.pageSize = 10;
          this.ipagination.total = 0;*/
            this.model = record;
          this.queryHttp(this.url.list, this.ipagination,record);
        },
        handleTableChange(pagination, filters, sorter) {
          this.ipagination = pagination;
          this.queryHttp(this.url.list, this.ipagination,this.model);
        },
        queryHttp(url, ipaginationObj,record) {
          this.queryParam.pageNo = ipaginationObj.current;
          this.queryParam.pageSize = ipaginationObj.pageSize;
          this.queryParam.entranceId = record.entranceId;
          getAction(url, this.queryParam).then((res) => {
            console.log("我的申请列表：",res);
            if (res.success) {
              console.log("current:" + res.result.current);
              console.log("total:" + res.result.total);
              this.dataSource = res.result.records;
              ipaginationObj.current = res.result.current;
              ipaginationObj.total = Number(res.result.total);
              ipaginationObj.pages = res.result.pages;
              console.log("this.dataSource：" + this.dataSource);


            }
          })
        },
        //绑定
        bind(appid){
          let param = {
            "applicationId": appid,
            "colId": this.model.id
          };
          httpAction("/hhemp/colApplication/empcolapplication", param, "post").then((res) => {
            if (res.success) {
              this.$message.success("绑定成功!");
              this.queryHttp(this.url.list, this.ipagination,this.model);
            } else {
              this.$message.error("绑定失败!");
            }
          }).finally(() => {
          })
        },
        //解绑
        unBind(appid){
          let param = {
            "applicationId": appid,
            "colId": this.model.id
          };
          httpAction("/hhemp/colApplication/deleteBycolIdAndappId", param, "post").then((res) => {
            if (res.success) {
              this.$message.success("解绑成功!");
              this.queryHttp(this.url.list, this.ipagination,this.model);
            } else {
              this.$message.error("解绑失败!");
            }
          }).finally(() => {
          })
        },
        handleOk() {
          // this.$refs.realForm.submitForm();
          // this.tocancel()
          this.close()
        },
        handleCancel() {
          this.close()
        },
        close() {
          this.ipagination={
            current: 1,
              pageSize: 10,
              showQuickJumper: false,
              showSizeChanger: false,
              total: 0
          }
          this.$emit('ok');
          this.visible = false;
        },
      }
    }
</script>

<style scoped>

</style>